import React from "react";
import Button from "../Button";
import { GatsbyImage } from "gatsby-plugin-image";

const BuilderBanner = ({ data }) => {
  return (
    <section className="relative h-[500px] md:h-[600px] w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full"></div>
      <GatsbyImage
        image={data.image.iconImage.asset.gatsbyImageData}
        alt={data.image.title}
        loading="eager"
        style={{ objectFit: "cover" }}
        className="w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center text-white px-4 sm:px-6 lg:px-8">
        {data.heading && (
          <h2
            className="text-[30px] md:text-[36px] font-bold mb-[8px] md:mb-[16px]"
            style={{
              color: data?.headingColor?.hex ?? "inherit",
            }}
          >
            {data.heading}
          </h2>
        )}
        {data.subheading && (
          <p
            className="text-[18px] md:text-[20px] mb-[16px] md:mb-[24px] max-w-[672px]"
            style={{
              color: data?.subheadingColor?.hex ?? "inherit",
            }}
          >
            {data.subheading}
          </p>
        )}
        {data.button?.title && (
          <div className="mt-20">
            <Button
              text={data.button.title}
              btnType={data.button.btnType}
              link={data.button.link}
              linkType={data.button.linkType}
              border="bordered-black"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default BuilderBanner;
